export default __webpack_public_path__ + "static/media/tl-Icon.5dc9ac09.png";